// extracted by mini-css-extract-plugin
export default {"label":"SwitchButton_label__n8N+C","switch":"SwitchButton_switch__hwrqz","slider":"SwitchButton_slider__ZZ-DE","round":"SwitchButton_round__Hw+r+"};